export const UMB_USER_DETAIL_REPOSITORY_ALIAS = 'Umb.Repository.User.Detail';
export const UMB_USER_DETAIL_STORE_ALIAS = 'Umb.Store.User.Detail';
